import { Pipe, PipeTransform } from '@angular/core'

import {
  CustomLabelValueMap,
  resolveSpeakerLabel,
} from './custom-label.service'

/**
 * テンプレート上の話者名を SkillMap 単位の表示用カスタムラベルに解決する pure pipe。
 */
@Pipe({
  name: 'speakerLabel',
  standalone: true,
  pure: true,
})
export class SpeakerLabelPipe implements PipeTransform {
  /** 話者名をカスタムラベル設定に基づいて表示名へ変換する。 */
  transform(speaker: string, labelValues: CustomLabelValueMap): string {
    return resolveSpeakerLabel(speaker, labelValues)
  }
}
